import React, {memo} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {contentMaxWidth, colors, fontSize, fontWeight, lineHeightRatio} from '@/styles/tokens';
import {renderParts} from './richText';
import type {solutionBannerContent} from '@/util/contents/drawpost-data';

interface SolutionBannerProps {
    heading: string;
    content: typeof solutionBannerContent;
    className?: string;
}

const sectionSx = {
    bgcolor: colors.accent.indigo
} as const;

const innerSx = {
    maxWidth: contentMaxWidth.standard,
    mx: 'auto',
    px: {xs: 3, md: 4},
    textAlign: 'center'
} as const;

const bodySx = {
    color: colors.text.inverse,
    fontSize: fontSize[16],
    fontWeight: fontWeight.regular,
    lineHeight: lineHeightRatio.looser,
    mt: 2
} as const;

const SolutionBanner = memo(function SolutionBanner({heading, content, className}: SolutionBannerProps) {
    return (
        <Box className={className} sx={sectionSx}>
            <Box sx={innerSx}>
                <Typography
                    variant="h1"
                    component="h2"
                    mb={3}
                    fontSize={{xs: 35, sm: 48}}
                    className="font-headers"
                    sx={{color: colors.text.inverse, lineHeight: lineHeightRatio.tight}}
                >
                    {heading}
                </Typography>

                {content.paragraphs.map((parts, i) => (
                    <Typography key={i} sx={bodySx} className="font-regular-text solution-link">
                        {renderParts(parts)}
                    </Typography>
                ))}
            </Box>
        </Box>
    );
});

export default SolutionBanner;
